export const environment = {
  production: true,
  buildId: '3520629848522451',
  configFile: 'config.json',
};
